//import { Timestamp } from "../store/timestampsReducer";

import { ITimestamp } from "../components/TimestampsSelector/timestamps";

export const TOGGLE_TIMESTAMP = "TOGGLE_TIMESTAMP";
export const TOGGLE_ALL_TIMESTAMPS = "TOGGLE_ALL_TIMESTAMPS";
export const SET_TIMESTAMPS = "SET_TIMESTAMPS";

export const ToggleTimestamp = (timestamp: ITimestamp) => {
    return { type: TOGGLE_TIMESTAMP, timestamp };
};

export const ToggleAllTimestamps = (availableTimestampsOrScenarios: ITimestamp[]) => {
    return { type: TOGGLE_ALL_TIMESTAMPS, availableTimestampsOrScenarios };
};

export const SetTimestamps = (timestamps: ITimestamp[]) => {
    return { type: SET_TIMESTAMPS, timestamps };
};
